import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.response.use((r) => r, (e) => {
  if (e?.response?.status === 402 && !window.location.pathname.startsWith("/abbonamento")) window.location.href = "/abbonamento";
  return Promise.reject(e);
});

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function formatError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => (d?.msg || JSON.stringify(d)).replace(/^Value error, /, "")).join(" ");
  return detail.msg || String(detail);
}

export const euro = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(Number(n) || 0);

export const prezzoFinale = (a) => {
  const p = Number(a.prezzo) || 0;
  const s = Number(a.sconto) || 0;
  const f = a.sconto_tipo === "euro" ? p - s : p * (1 - s / 100);
  return Math.max(0, Math.round(f * 100) / 100);
};

export const scontoLabel = (a) => (a.sconto ? (a.sconto_tipo === "euro" ? `-${euro(a.sconto)}` : `-${a.sconto}%`) : "");

export const dataIt = (s) => {
  if (!s) return "—";
  const d = new Date(s);
  return isNaN(d) ? s : d.toLocaleDateString("it-IT");
};

export const STATI_PREVENTIVO = [
  { value: "bozza", label: "Bozza", cls: "bg-slate-100 text-slate-700 border-slate-300" },
  { value: "inviato", label: "Inviato", cls: "bg-sky-50 text-sky-800 border-sky-300" },
  { value: "accettato", label: "Accettato", cls: "bg-emerald-50 text-emerald-800 border-emerald-300" },
  { value: "rifiutato", label: "Rifiutato", cls: "bg-rose-50 text-rose-700 border-rose-300" },
  { value: "convertito", label: "In lavorazione", cls: "bg-orange-50 text-orange-800 border-orange-300" },
];

export const STATI = [
  { value: "aperto", label: "Aperto" },
  { value: "in_lavorazione", label: "In lavorazione" },
  { value: "completato", label: "Completato" },
  { value: "consegnato", label: "Consegnato" },
];

export const STATI_NOLEGGIO = [
  { value: "prenotato", label: "Prenotato" },
  { value: "in_corso", label: "In corso" },
  { value: "restituito", label: "Restituito" },
  { value: "annullato", label: "Annullato" },
];
export const STATI_FLOTTA = [
  { value: "disponibile", label: "Disponibile" },
  { value: "manutenzione", label: "In manutenzione" },
  { value: "fuori_servizio", label: "Fuori servizio" },
];
export const dataOraIt = (s) => (s ? `${dataIt(s.slice(0, 10))} ${s.slice(11, 16)}` : "—");

export const TIPI_BICI = ["MTB", "Corsa", "Gravel", "E-Bike", "City", "Trekking", "BMX", "Bambino", "Altro"];
export const CATEGORIE_RICAMBI = ["Freni", "Trasmissione", "Copertoni e camere", "Ruote", "Sospensioni", "Elettronica", "Telaio e componenti", "Altro"];
export const CATEGORIE_PRODOTTI = ["Bici nuove", "Abbigliamento", "Caschi", "Accessori", "Attrezzi", "Nutrizione", "Altro"];
